import React, { useEffect } from "react";
import "./styles.css";
import { Link, useNavigate } from "react-router-dom";

export default function Cortador() {
  const navigate = useNavigate();
  
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <div className="contrato-container">
      <div style={{ marginBottom: 30 }}>
         <Link onClick={handleGoBack}>Voltar para o Cadastro</Link>
      </div>
      <h1>CONTRATO DE DIVULGAÇÃO DE CONTEÚDO</h1>

      <section>
        <h2>DO OBJETO</h2>
        <p>
          Cláusula 1 - Este contrato tem como objeto a parceria entre as partes,
          visando à divulgação de vídeos de cortes de conteúdo do canal oficial
          @orodrigodom, com base nos materiais fornecidos pelo CONTRATANTE, para
          promoção e engajamento nas redes sociais, com cláusulas abaixo
          estipuladas.
        </p>
      </section>

      <section>
        <h2>DA RESPONSABILIDADE DO PARCEIRO 1</h2>
        <p>
          Cláusula 2 Disponibilizar ao Parceiro 2 os vídeos e demais materiais
          de divulgação para cortes, por meio de uma plataforma de
          compartilhamento pelo Google drive através do link disponível no grupo
          de cortes.
        </p>
        <p>
          Cláusula 2.1 Garantir que o conteúdo disponibilizado seja autorizado
          para divulgação e já tenha sido postado no canal oficial do Rodrigo.
        </p>
        <p>
          Cláusula 2.3 Monitorar os canais de cortes, garantindo que estejam
          cumprindo as diretrizes de divulgação e não estejam se passando pelo
          perfil oficial.
        </p>
        <p>
          Cláusula 2.4 Fornecer um Dashboard para acompanhamento dos resultados
          gerados pelos canais de corte, de forma transparente, para que ambos
          possam verificar o desempenho dos vídeos.
        </p>
        <p>
          Cláusula 2.5 Garantir que o cálculo das receitas e pagamentos seja
          feito de forma precisa e dentro dos prazos estabelecidos.
        </p>
        <p>
          Cláusula 2.6 Sinalizar ao CONTRATADO qualquer irregularidade ou
          comportamento inadequado que viole as regras de conduta do canal de
          cortes ou uso indevido dos conteúdos.
        </p>
      </section>

      <section>
        <h2>DAS RESPONSABILIDADES DO PARCEIRO 2</h2>
        <p>
          Cláusula 3 Manter claro, em todas as suas postagens e na “bio” do
          perfil de cortes, que o canal é exclusivamente de cortes do conteúdo
          do Rodrigo, seguindo o padrão determinado, sem jamais se passar por
          ele ou por seu perfil oficial.
        </p>
        <p>
          Cláusula 3.1 Utilizar exclusivamente os materiais fornecidos pelo
          CONTRATANTE através do Drive ou de outros meios autorizados.
        </p>
        <p>
          Cláusula 3.2 Não divulgar nenhum material que ainda não tenha sido
          publicado no canal oficial, assumindo total responsabilidade por
          qualquer conteúdo postado de forma inadequada ou sem a devida
          autorização, bem como material de outras pessoas.
        </p>
        <p>
          Cláusula 3.3 Monitorar as interações e os comentários em seu canal de
          cortes. Em casos de excesso de “hater” ou comportamento inadequado por
          parte do público, o CONTRATADO deve comunicar a equipe do Link do Bem
          para que sejam tomadas as devidas providências.
        </p>
        <p>
          Cláusula 3.4 Acompanhar seu próprio desempenho através do Dashboard,
          que será disponibilizado pelo CONTRATANTE, e utilizar esses dados para
          ajustar suas estratégias de divulgação, se necessário.
        </p>
        <p>
          Cláusula 3.5 Promover os vídeos de cortes de forma ética e dentro das
          regras estabelecidas, sem manipulação indevida do conteúdo
        </p>
        <p>
          Cláusula 3.6 O CONTRATADO será o único responsável pela gestão e
          controle de seu canal de cortes, assumindo integralmente as
          consequências por qualquer infração às diretrizes deste contrato ou
          uso indevido dos materiais.
        </p>
      </section>

      <section>
        <h2>DAS POLÍTICAS E DIRETRIZES DO GOOGLE</h2>
        <p>
          Cláusula 4 - O PARCEIRO 2 deve seguir as diretrizes e procedimentos
          estabelecidos pela contratante para a realização das atividades do
          projeto, garantindo consistência e conformidade com os objetivos
          estabelecidos, bem como se obriga a ler e seguir todas as políticas do
          Google, para não incorrer em qualquer ação de bloqueio da plataforma.
        </p>
        <p>
          Cláusula 4.1 - Em casos de violação das diretrizes da Plataforma
          Google, o PARCEIRO 2 será advertido.
        </p>
      </section>

      <section>
        <h2>DO PAGAMENTO</h2>
        <p>
          Cláusula 4.1 - Em casos de violação das diretrizes da Plataforma
          Google, o PARCEIRO 2 será advertido.
        </p>
        <p>
          Cláusula 5.1 - Após o desconto de 15% do valor bruto para o pagamento
          da plataforma Google, o Parceiro 2 receberá a porcentagem de 50%
          (cinquenta por cento) do valor remanescente do valor gerado através do
          seu link de afiliado.
        </p>
        <p>
          Cláusula 5.2- Em caso de desativação da conta Adsense, ou seja, caso a
          Plataforma Google suspenda ou desative a conta comprovadamente, os
          valores retidos não serão repassados.
        </p>
        <p>
          Cláusula 5.3 - O pagamento será realizado após o influenciador emitir
          nota fiscal no dia 01 referente aos serviços prestados na campanha,
          notas enviadas após às 16:00 serão pagas no dia seguinte.
        </p>
        <p>
          Cláusula 5.4 - O valor apresentado no dash é apenas uma estimativa,
          sendo que o valor correto será enviado pelo financeiro, com o valor
          correto para a emissão da NF.
        </p>
      </section>

      <section>
        <h2>DA EMISSÃO DE NOTAS FISCAIS E PRAZOS DE PAGAMENTO</h2>
        <p>
          Para manter a organização e o bom funcionamento do nosso fluxo financeiro, a partir de
          agora adotaremos um cronograma fixo de pagamentos, vinculado à emissão das notas
          fiscais
        </p>

        <p>Pagamentos serão realizados em duas etapas:</p>
        <ul>
          <li>
            Quem enviar a nota fiscal até às 16h do dia 01 (desde que seja dia útil), receberá no
            mesmo dia. Caso o dia 01 não seja útil, o pagamento será efetuado no próximo dia
            útil.
          </li>
          <br />
          <li>
            Quem enviar a nota fiscal entre os dias 02 e 10 do mês, receberá o pagamento no
            dia 11 (ou no próximo dia útil, caso o dia 11 não seja útil).
          </li>
        </ul>
        <b>Importante:</b>
        <br />
        <p>
          A nota fiscal referente ao valor acordado no mês vigente deve ser emitida até o dia 10 do
          mês. Caso isso não ocorra, será concedido um prazo de tolerância e a emissão deverá
          ocorrer entre o dia 01 e 10 do mês subsequente.
        </p>

        <p>
          Se a nota não for emitida até essa data, o valor correspondente será destinado a doações
          sociais, entendendo-se que a ausência da emissão dentro do prazo caracteriza renúncia ao
          recebimento.
        </p>

        <p>
          Nosso objetivo com essa medida é garantir mais previsibilidade, responsabilidade e
          agilidade no processo de repasse, além de evitar acúmulos e impactos no planejamento
          financeiro de ambas as partes.
        </p>

        <p>Agradecemos a compreensão e estamos à disposição para esclarecer quaisquer dúvidas.</p>
      </section>

      <section>
        <h2>DA RESCISÃO</h2>
        <p>
          Cláusula 6 - Este contrato poderá ser rescindido a qualquer momento
          por acordo mútuo das partes, mediante comunicação por escrito com
          aviso prévio de 7 dias.
        </p>
        <p>
          Cláusula 6.2 Caso a rescisão ocorra por justa causa, a parte infratora
          poderá ser responsabilizada por eventuais danos e prejuízos causados à
          outra parte, conforme apurado judicialmente ou por comum acordo,
          acrescida de multa por violação contratual no valor de R$5.000,00
          (cinco mil reais).
        </p>
        <p>
          Cláusula 6.3 Em caso de rescisão, o Parceiro 2 deverá apagar todos os
          vídeos postados, objeto deste contrato.
        </p>
      </section>

      <section>
        <h2>DA VIGÊNCIA</h2>
        <p>
          Cláusula 7 - O presente contrato terá vigência indeterminada, ou seja,
          durante toda a duração da parceria, podendo ser rescindido a qualquer
          momento, mediante aviso prévio de 7 (sete) dias, sem ônus para as
          partes. Qualquer alteração contratual será encaminhada no e-mail do
          cortador e o mesmo deverá dar o aceite
        </p>
      </section>

      <section>
        <h2>DA CONFIDENCIALIDADE E SIGILO</h2>
        <p>
          Cláusula 8 Durante a vigência deste contrato, ambas as partes
          concordam em considerar como informações confidenciais todos os dados,
          documentos, conhecimentos técnicos, estratégias de negócios, planos de
          marketing, valores, comissões e quaisquer outras informações
          divulgadas ou obtidas em virtude deste contrato.
        </p>
        <p>
          Cláusula 8.1 As partes se comprometem a manter em estrito sigilo todas
          as informações confidenciais, não divulgando, reproduzindo ou
          utilizando tais informações para qualquer fim que não esteja
          relacionado à execução deste contrato, exceto mediante consentimento
          prévio por escrito da parte proprietária das informações.
        </p>
        <p>
          Cláusula 8.3 Em caso de violação desta cláusula de confidencialidade,
          a parte prejudicada terá direito a buscar medidas legais apropriadas,
          incluindo indenização por perdas e danos, e medidas cautelares ou
          injunções para prevenir ou cessar a violação.
        </p>
      </section>

      <section>
        <h2>KNOW HOW</h2>
        <p>
          Cláusula 9 Para os propósitos deste contrato, "know-how" refere-se a
          qualquer conhecimento, habilidade, técnica, método, informação técnica
          ou comercial, experiência prática e expertise acumulada pela
          contratante no desenvolvimento e execução do projeto Link do Bem.
        </p>
        <p>
          Cláusula 9.1 O parceiro 2 reconhece que o know-how fornecido pela
          contratante é confidencial e exclusivo, e concorda em utilizá-lo
          estritamente para os fins deste contrato.
        </p>
        <p>
          Cláusula 9.2 O Parceiro 2 não deverá, em momento algum, divulgar,
          reproduzir, modificar, ou utilizar o know-how para qualquer fim que
          não esteja diretamente relacionado à execução deste contrato.
        </p>
        <p>
          Cláusula 9.3 Todo o know-how fornecido pelo Parceiro 1 permanecerá de
          propriedade exclusiva desta, e a contratada não adquirirá quaisquer
          direitos de propriedade sobre o mesmo, nem durante a vigência deste
          contrato, nem após o seu término.
        </p>
        <p>
          Cláusula 9.4 O Parceiro 2 não deverá, em momento algum, transferir ou
          fornecer a terceiros qualquer parte do know-how fornecido pela
          contratante, seja de forma direta ou indireta.
        </p>
      </section>

      <section>
        <h2>DO DIREITO AUTORAL E À IMAGEM</h2>
        <p>
          Cláusula 10 O Parceiro 1 concede ao Parceiro 2 o direito de utilização
          não exclusivo do referido conteúdo, para fins estritamente
          relacionados ao objeto deste contrato, incluindo sua divulgação,
          reprodução e distribuição em quaisquer meios e plataformas, de forma
          temporária, durante a vigência deste contrato, sem caráter de cessão
          definitiva dos direitos autorais ou de imagem.
        </p>
        <p>
          Cláusula 10.1 O uso do conteúdo pelo Parceiro 2 não implica em
          transferência de propriedade dos direitos autorais ou de imagem, os
          quais permanecem integralmente com o Parceiro 1, sendo vedada a
          alteração, reprodução ou distribuição do conteúdo para finalidades
          distintas das previstas neste contrato sem a prévia e expressa
          autorização do Parceiro 1.
        </p>
      </section>

      <section>
        <h2>DO FORO</h2>
        <p>
          Cláusula 11 Para dirimir quaisquer controvérsias decorrentes deste
          contrato, as partes elegem o foro da comarca de São Paulo, renunciando
          a qualquer outro, por mais privilegiado que seja.
        </p>
      </section>

      <p className="assinatura">São Paulo.</p>

      <span>Última atualização: 03/07/2025</span>

      <br />

      <Link to={"/cadastro"}>Voltar para o Cadastro</Link>
    </div>
  );
}
